@if (dfmCheck) {
  <div
    (click)="onToggleDFMCheck()"
    [class]="
      'my-2 border border-surface p-4 rounded-lg hover:cursor-pointer transition-all' +
      (selectedDFMCheck?.id === dfmCheck.id
        ? ' ring-2 ring-inset ring-primary'
        : ' hover:bg-surface-switch-100')
    "
  >
    <!-- Header: icon + name on left, status tag on right -->
    <div class="flex items-center justify-between gap-3">
      <div class="flex items-center gap-3">
        <span class="bg-surface-switch-100 p-2 rounded-md shrink-0">
          <i [class]="checkTypeIcon(dfmCheck.check_type) + ' text-xl'"></i>
        </span>
        <span class="font-medium">{{
          checkTypeName(dfmCheck.check_type)
        }}</span>
      </div>
      <p-tag
        [value]="statusDisplay(dfmCheck.status)"
        [severity]="statusSeverity(dfmCheck.status)"
      ></p-tag>
    </div>

    @if (checkDescription) {
      <p class="mt-2 text-sm text-muted-color leading-relaxed">
        {{ checkDescription }}
      </p>
    }

    @if (dfmCheck.quantity !== null && quantityToFloat(dfmCheck.quantity) > 0) {
      <div class="mt-3">
        <span
          [class]="
            'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ' +
            (isWarningType(dfmCheck.check_type) &&
            quantityToFloat(dfmCheck.quantity) > 0
              ? 'bg-red-50 text-danger'
              : 'bg-surface-switch-100')
          "
        >
          @if (
            isWarningType(dfmCheck.check_type) &&
            quantityToFloat(dfmCheck.quantity) > 0
          ) {
            <i class="pi pi-exclamation-triangle text-xs"></i>
          }
          {{ formatQuantity(dfmCheck) }}
        </span>
      </div>
    }

    @if (checkParams.length > 0) {
      <div class="mt-3 pt-2 border-t border-surface">
        <span class="text-xs text-muted-color font-medium"
          >Parameters used</span
        >
        <div class="mt-1 flex flex-wrap gap-1.5">
          @for (param of checkParams; track param.label) {
            <span
              class="inline-flex items-center gap-1 bg-surface-switch-100 rounded px-2 py-0.5 text-xs font-mono"
            >
              <span class="text-muted-color">{{ param.label }}:</span>
              <span class="font-medium">{{ param.value }}</span>
            </span>
          }
        </div>
      </div>
    }

    @if (showBlockingUpStepDownload) {
      <div
        class="mt-3 pt-2 border-t border-surface"
        (click)="$event.stopPropagation()"
      >
        <p-button
          type="button"
          label="Download blocking-up STEP"
          icon="pi pi-download"
          [outlined]="true"
          size="small"
          styleClass="w-full sm:w-auto"
          (onClick)="downloadBlockingUpStep()"
        />
      </div>
    }
  </div>
}
